import { Box } from '@mui/material';
import { Product } from 'generated/graphql';
import { ProductHelper } from 'helpers/ProductHelper';
import { deprecatedColors } from 'styles/theme/deprecatedColors';

type VariantsProps = {
    product: Product;
};

export function ProductListVariants(props: VariantsProps) {
    const { product } = props;

    const choices = ProductHelper.getChoices(product);

    return (
        <Box
            marginY={1}
            display="flex"
            flexWrap="wrap"
            justifyContent="flex-start"
            gap={1}
        >
            {choices.map((item, index) => (
                <div key={index}>
                    <Box
                        title={item?.label ?? ''}
                        sx={{
                            borderRadius: '50%',
                            margin: '0 auto',
                            padding: '8px',
                            overflow: 'hidden',
                            width: 16,
                            height: 16,
                            backgroundColor: item?.color ?? deprecatedColors.transparent.white50,
                        }}
                    />
                </div>
            ))}
        </Box>
    );
}
